/**
 * Computes the visible page numbers (0-based) for a pagination control
 * using a sliding window of up to 5 pages. No ellipsis — the window
 * shifts left/right to keep the current page centered when possible.
 */
export function computeVisiblePages(pageIndex: number, totalPages: number): number[] {
  if (totalPages <= 0) return [];

  const windowSize = Math.min(5, totalPages);
  const half = Math.floor(windowSize / 2);

  let start = Math.max(0, pageIndex - half);
  const end = Math.min(totalPages - 1, start + windowSize - 1);
  // Adjust start if end was clamped at the right edge
  start = Math.max(0, end - windowSize + 1);

  const pages: number[] = [];
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }
  return pages;
}
